import React from 'react';
import {Button,Select,Input,Checkbox} from 'antd';
import {connect} from 'react-redux';
import AjaxAction from '../../actions/AjaxAction.js';
import {cross} from '../../util/index.js';
import './index.scss';

const CheckboxGroup = Checkbox.Group;

let GalleryCache = {
    expires:Date.now(),
    data:null
};

class GallerySelect extends React.Component {
    state = {
        gallerylist:null,
        infolist:[]
    };

    componentDidMount() {
        this.checkGalleryList(this.props.parentGallery);
    }

    componentWillReceiveProps(nextProps) {
        this.checkGalleryList(nextProps.parentGallery);
    }

    checkGalleryList(id) {
        if(!this.state.gallerylist) {
            let {dispatch} = this.props;
            let {data,expires} = GalleryCache;
            var that = this;

            function doFetch() {
                var promise = dispatch(AjaxAction.gallerys({
                    pagesize:500,
                    page:1,
                    key:JSON.stringify({
                        parent:id
                    })
                })).then(res=>{
                    GalleryCache.data = res.data;
                    GalleryCache.expires = Date.now() + 300000;

                    that.setState({
                        gallerylist:res.data.filter(it=>!!it.name)
                    });

                    return res;
                });

                GalleryCache.data = promise;
            }

            if(data && data instanceof Promise) {
                data.then(res=>{
                    that.setState({
                        gallerylist:res.data.filter(it=>!!it.name)
                    });
                })
            }
            else {
                if(!data || (data && expires <= Date.now())) {
                    doFetch();
                }else {
                    that.setState({
                        gallerylist:data.filter(it=>!!it.name)
                    });
                }
            }
        }
    }

    setKeyValue(e) {
        this.props.onChange(e);
        // this.props.onChange(infolist);
    }

    render() {
        let {value, filter, disabled} = this.props;
        let {gallerylist} = this.state;

        if(value) {
            if(typeof value == 'string') {
                value = JSON.parse(value);
            }
        }else {
            value = [];
        }

        return (
            <div className="dp-f gallery-select" style={{flexDirection:"column"}}>
                <CheckboxGroup options={(gallerylist || []).map(it=>{
                    return {label:it.name, value:it.id};
                })} value={value} onChange={this.setKeyValue.bind(this)} />
            </div>
        );
    }
}

export default connect()(GallerySelect);



// WEBPACK FOOTER //
// ./src/components/Select/GallerySelect.js